export class SchemaError extends Error {
    readonly name: string = "SchemaError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
